// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_bp-0";
export var actionModalContentContainer = "_bp-1";
export var createTagButton = "_bp-2";
export var footerContainer = "_bp-7";
export var fullWidthDivider = "_bp-3";
export var hasCreateTagButton = "_bp-4";
export var noCreateTagButton = "_bp-5";
export var tagsContainer = "_bp-6";
export var tagsModalContentContainer = "_bp-8";